export enum PlayerId {
    Unset = 0,
    Human = 1,
    CPU = 2,
    Neither = 3,
};